
import Vue from 'vue'

import App from './App.vue'
import router from './router.js'
import './moment'
import './vee-validate'
import './toast'
import store from './store'
import axios from "./axios";
import "vue-select/dist/vue-select.css";
// import './event_bus'


global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

Vue.prototype.$http = axios;

import './../node_modules/slick-carousel/slick/slick.css';
import '../public/css/style.scss';
import 'promise-polyfill/src/polyfill';

new Vue({
	router:router,
	store,
	render: h => h(App)
}).$mount('#app')
